function initializeQuantityBundles() {
  const quantityBundleButtons = document.querySelectorAll('.js-quantity-bundle-button');

  quantityBundleButtons.forEach((radio) => {
    radio.addEventListener('change', updatePrices);
  });

  // Listen for the custom event globally
  document.addEventListener('quantityBundleReset', (event) => {
    const price = event.detail.price;
    const firstRadio = document.querySelector('.js-quantity-bundle-button:checked');
    if (firstRadio) {
      updatePrices.call(firstRadio, event, price);
    }
  });

  if (quantityBundleButtons.length > 0) {
    quantityBundleButtons[0].checked = true;
    quantityBundleButtons[0].dispatchEvent(new Event('change'));
  }

  subscribe(PUB_SUB_EVENTS.quantityUpdate, () => {
    const checkedRadio = document.querySelector('.js-quantity-bundle-button:checked');
    if (!checkedRadio) return;

    checkedRadio.dispatchEvent(new Event('change'));
  });
}

function currencyFormatter(value, country, language, currency) {
  return new Intl.NumberFormat(`${language}-${country}`, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(value);
}

// Quantity Per Pack selectors
function getQuantityPerPack(quantity) {
  const sizeLabel = document.querySelector('input[type="radio"].option-size-radio:checked');
  const countLabel = document.querySelector('.variant-qty-count');
  let quantityPerPack;

  if (sizeLabel) {
    quantityPerPack = parseInt(sizeLabel.dataset.quantityPerPack);
  } else if (countLabel) {
    const extractNumber = (str) => parseInt(str.match(/\d+/)?.[0] || null);
    quantityPerPack = extractNumber(countLabel.textContent);
  }

  if (quantityPerPack && document.querySelector('.product-quantity')) {
    document.querySelector('.product-quantity').textContent = (
      quantityPerPack * quantity
    ).toString();
  }

  return quantityPerPack;
}

function updatePrices(event, overridePrice) {
  const priceElement = document.querySelector('.js-price-unit');
  const quantityInput = document.querySelector('.quantity__input');
  const subtotalElement = document.querySelector('.js-price-subtotal');
  const mainPriceElement = document.querySelector('.price-item.price-item--regular.js-price-unit');
  const pricePerPiece = document.querySelector('.js-price-per-piece');

  const {country, language, currency} = window.ShopifyLocalization;

  const priceNumber = overridePrice || priceElement.dataset.priceNumber;

  const quantity = parseInt(this.dataset.quantity);
  const discount = parseInt(this.dataset.discount) || 0;

  quantityInput.value = quantity;

  const discountAmount = Math.floor((priceNumber / 100) * (discount / 100) * 100) / 100;

  const bundlePrice = (priceNumber / 100 - discountAmount).toFixed(2);

  const discountedPrice = bundlePrice * quantity;

  // Calculate original price for comparison
  const originalTotalPrice = ((priceNumber * quantity) / 100).toFixed(2);

  if (discount > 0) {
    subtotalElement.innerHTML = `<span class="striketrough">${currencyFormatter(originalTotalPrice, country, language, currency)}</span>&nbsp;${currencyFormatter(discountedPrice, country, language, currency)}`;
  } else {
    subtotalElement.innerHTML = `${currencyFormatter(discountedPrice, country, language, currency)}`;
  }
  mainPriceElement.innerHTML = currencyFormatter(bundlePrice, country, language, currency);

  const quantityPerPack = getQuantityPerPack(quantity);

  if (quantityPerPack) {
    const pricePerPieceValue = bundlePrice / quantityPerPack;
    pricePerPiece.innerHTML = `${currencyFormatter(pricePerPieceValue, country, language, currency)}`;
  }
  getQuantityPerPack(quantity);
}

document.addEventListener('DOMContentLoaded', initializeQuantityBundles);
